module.exports = "js/webpack/492f40d01cb4aa7e66fbae9f01abda49.png";